export const urls = {
  userinfo: '/api/web-login/userinfo',
  leaderboard: '/api/players/leaderboard/',
  matches: '/api/matches',
  users: '/api/players'
}
